define(["require", "exports", "../../core/bootstrap/BootstrapBus", "../logs/LogsManager", "../utils/UtilsLocalStorage", "./BootstrapSkeleton"], function (require, exports, BootstrapBus_1, LogsManager_1, UtilsLocalStorage_1, BootstrapSkeleton_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.BootStrapClassManager = void 0;
    var BootStrapClassManager = (function () {
        function BootStrapClassManager() {
            this._sceneModeKey = 'scene-data';
        }
        BootStrapClassManager.getInstance = function () {
            if (!BootStrapClassManager.instance) {
                BootStrapClassManager.instance = new BootStrapClassManager();
            }
            return BootStrapClassManager.instance;
        };
        BootStrapClassManager.prototype.getConfig = function () {
            return this._config;
        };
        BootStrapClassManager.prototype.getLogsManager = function () {
            return this._logsManager;
        };
        BootStrapClassManager.prototype.setConfig = function (value, i18n, vueObj) {
            this._config = value;
            this._config.i18n = i18n;
            this._config.locale = i18n.locale;
            this._logsManager = new LogsManager_1.LogsManager();
            this._logsManager.monitor(vueObj);
            this._skeletonManager = new BootstrapSkeleton_1.BootstrapSkeleton();
            this._skeletonManager.monitor();
            this.addSceneMode();
        };
        BootStrapClassManager.prototype.addSceneMode = function () {
            BootstrapBus_1.busEvent.$on(BootstrapBus_1.EventBusEnum.APPS_SCENE_UPDATE, this.onSceneUpdate.bind(this));
        };
        BootStrapClassManager.prototype.onSceneUpdate = function (event) {
            if (event) {
                if (event.userData) {
                    if (event.sceneData) {
                        var sceneData = this.saveSceneDataToCache(event.userData, event.sceneData);
                        this.feedBackStore(sceneData);
                    }
                    else {
                        var sceneData = this.restoreSceneDataFromCache(event.userData);
                        this.feedBackStore(sceneData);
                    }
                }
            }
        };
        BootStrapClassManager.prototype.getRestoreKey = function (userData) {
            var key = this._sceneModeKey;
            if (userData && userData.id) {
                return "".concat(key, "-").concat(userData.id);
            }
            return key;
        };
        BootStrapClassManager.prototype.restoreSceneDataFromCache = function (userData) {
            var sceneData;
            try {
                var config = this.getConfig();
                sceneData = (0, UtilsLocalStorage_1.getLocalStorage)(this.getRestoreKey(userData));
                if (sceneData) {
                    config.sceneData = sceneData;
                }
            }
            catch (error) {
                console.log('restoreSceneDataFromCache error', error);
            }
            return sceneData;
        };
        BootStrapClassManager.prototype.saveSceneDataToCache = function (userData, sceneData) {
            try {
                var config = this.getConfig();
                config.sceneData = sceneData;
                (0, UtilsLocalStorage_1.setLocalStorage)(this.getRestoreKey(userData), sceneData);
            }
            catch (error) {
                console.log('saveSceneDataToCache error', error);
            }
            return sceneData;
        };
        BootStrapClassManager.prototype.feedBackStore = function (sceneData) {
            if (sceneData) {
                BootstrapBus_1.busEvent.$emit(BootstrapBus_1.EventBusEnum.APPS_SCENE_FEED_BACK, sceneData);
            }
        };
        BootStrapClassManager.prototype.saveParamsData = function (params) {
            if (params) {
                this._params = params;
            }
        };
        BootStrapClassManager.prototype.getParams = function () {
            return this._params;
        };
        BootStrapClassManager.prototype.saveThemeConfigData = function (themeData) {
            if (themeData) {
                if (themeData.code && themeData.data && themeData.data.length) {
                    var themeDataList = themeData.data;
                    this._themeData = {};
                    for (var index = 0; index < themeDataList.length; index++) {
                        var value = themeDataList[index];
                        switch (value.configKey) {
                            case 'theme-color':
                                this._themeData.themeColor = value;
                                break;
                            case 'font-color':
                                this._themeData.fontColor = value;
                                break;
                            case 'show-nav-bar':
                                this._themeData.showNavBar = value;
                                break;
                            case 'nav-bar-color':
                                this._themeData.navBarColor = value;
                                break;
                            case 'idcard-photo-optional':
                                this._themeData.idcardPhotoOptional = value;
                                break;
                            case 'skip-guide':
                                this._themeData.skipGuide = value;
                                break;
                            case 'show-collect-agreement':
                                this._themeData.showCollectAgreement = value;
                                break;
                            case 'nav-bar-content':
                                this._themeData.navBarContent = value;
                                break;
                        }
                    }
                }
                else {
                    this._themeData = themeData;
                }
            }
        };
        BootStrapClassManager.prototype.getThemeConfigData = function () {
            return this._themeData;
        };
        return BootStrapClassManager;
    }());
    exports.BootStrapClassManager = BootStrapClassManager;
});
//# sourceMappingURL=BootstrapClassManager.js.map